module.exports = __webpack_public_path__ + "static/img/showroom7.80a82b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/showroom7.png
// module id = OUoZ
// module chunks = 2